<template>
    <div class="the-tips" :class="{'tips-sp': $store.state.screen == 1}">
        <div>{{msg}}</div>
    </div>
</template>

<script>
    export default {
        props: {
            msg: String | Object
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../static/tctransition";
    // 横屏css
    .the-tips {
        color: #fff;
        font-size: 38px;
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.8);
        padding: 20px 30px;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        word-break: break-all;
    }
    // 竖屏css
    .tips-sp {
        font-size: 69px;
        border-radius: 18px;
        padding: 36px 54px;
    }
</style>